import Axios from 'axios';

export const api = Axios.create({
  // baseURL: 'https://api.konnektive.com/',
  baseURL: 'http://127.0.0.1:8000/',
});